export default "__VITE_ASSET__BauOmuj7__"